export default __webpack_public_path__ + "static/media/tp-header.705ee1be.webp";